import { Rule } from "pages/Rules/common/types";
import { getCloudStorage as getStorage } from "pages/Rules/Form/context/ruleSelectors";

export type EmailActionType =
  | Storage["onStorageError"]["emailAction"]["type"]
  | "DEFAULT";

export default function getEmailActionType(rule: Rule): EmailActionType {
  const storage = getStorage(rule);
  return storage.onStorageError?.emailAction?.type || "DEFAULT";
}
